import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from "web-vitals";
import { supabase } from "@/integrations/supabase/client";

// Sample only a fraction of sessions to keep DB writes low.
const SAMPLE_RATE = 0.25;

const queue: Array<Record<string, unknown>> = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  if (queue.length === 0) return;
  const batch = queue.splice(0, queue.length);
  // Fire-and-forget; failure is non-fatal.
  void supabase.from("web_vitals").insert(batch as never);
}

function enqueue(metric: Metric) {
  queue.push({
    metric: metric.name,
    value: Math.round(metric.value * 1000) / 1000,
    rating: metric.rating,
    path: typeof window !== "undefined" ? window.location.pathname : "/",
    navigation_type: metric.navigationType ?? null,
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 255) : null,
  });
  if (flushTimer) clearTimeout(flushTimer);
  flushTimer = setTimeout(flush, 1500);
}

export function initWebVitals() {
  if (typeof window === "undefined") return;
  // Skip admin/internal routes entirely.
  const path = window.location.pathname;
  if (path.startsWith("/cms") || path.startsWith("/seo-audit") || path.startsWith("/ai-generator")) {
    return;
  }
  if (Math.random() > SAMPLE_RATE) return;

  onLCP(enqueue);
  onCLS(enqueue);
  onINP(enqueue);
  onFCP(enqueue);
  onTTFB(enqueue);

  // Flush remaining metrics on page hide.
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
}
